<template>
    <div class="enterpriseDistribution">
        <section class="selectFixed">
            <div class="bg_fff fixedBox flex_box fs14">
                <p :class="{ upIcon: isOpen }" @click="openOptions()">{{ industryActive }}
                    <img src="../assets/img/icon/icon_down_black.svg" alt="downIcon">
                </p>
            </div>
        </section>
        <p class="fs12 co_333 mainContent bg_fff" v-html="content"></p>
        <HealthRank v-if="renderList" :renderData="renderList" :onlyList="true"></HealthRank>
        <div class="health_tip">
            <p>此榜单仅展示部分企业，如需获得完整榜单请联系客服</p>
        </div>
        <section v-if="isOpen" class="popupChooseBox">
            <EventChoose :popupVisible="isOpen" renderType="industry" :activeOption="industryActive"
                         @selectedOption="selectedOption"></EventChoose>
        </section>

        <section class="loadingBg" v-if="loading">
            <mt-spinner type="double-bounce" color="#26a2ff"></mt-spinner>
        </section>
    </div>
</template>

<script>
import _co from "../util/const";
import common from "@/util/common";


export default {
    name: "EnterpriseDistribution",
    components: {
        EventChoose(render) {
            require(["@/components/common/EventChoose"], render)
        },
        HealthRank(render) {
            require(["@/components/entity/HealthRank"], render)
        },
    },
    data() {
        return {
            loading: false,
            isOpen: false,
            renderList: null,
            industryActive: '全行业',
            content: "",
        }
    },
    mounted() {
        let {industry} = this.$route.query;
       if(industry)
           this.industryActive = common.convertEntityName(industry);

        this.getData()
    },
    methods: {
        openOptions() {
            this.isOpen = true;
        },
        async getData() {
            this.loading = true;
            let params = {
                industry:  _co.industryLabelMap[this.industryActive],
                sort: '正序',
            }
            this.renderList = null;
            let res = await this.baseApi.healthRankNew(params)
            if (res !== 'confirm') {
                this.renderList = res;
                let { percentageList = [], companyCount} = res;
                if (percentageList.length) {
                    let industryLabel = params.industry === '金融业' ? '金融' : params.industry;
                    this.content = `<p class="mainContent fs12 co_ff4">今日，系统监测覆盖全国${industryLabel}行业${companyCount}家金融机构，其中有${percentageList[0].percentage}%的舆情健康情况为优秀、${percentageList[1].percentage}%为良好、${percentageList[2].percentage}%为一般。</p>`
                }
            }

            this.loading = false;
        },
        selectedOption(data) {
            this[data.keyword] = data.value;
            this.isOpen = false;
            this.getData();
        },
    }
}
</script>

<style lang="scss" scoped>
.enterpriseDistribution {
    .mainContent {
        padding: 8px 16px;
        line-height: 20px;
    }
}
</style>